/*
 * Action Types
 */
export enum ModalFilterTypes {
  SET_OPEN_MODAL = '@modalFilter/SET_OPEN_MODAL',
}

/*
 * State type
 */
export interface ModalFilterState {
  readonly openModal: boolean;
  readonly error: boolean;
  readonly loading: boolean;
}
